import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icons from "assets/icons";
import Icon from "@ant-design/icons";
import React from "react";
import {Space, Button, Typography, Row} from "antd";

const {RADIO_BUTTON, INPUT, RADIO, CHECKBOX} = FIELD_TYPE;

const labelCol = {xs: 6, md: 6, lg: 6};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

export const FieldsExtraocular1: Array<DataFormField> = [
  {
    name: [
      "rightJsonValue",
      "EXTRAOCULAR_MOVEMENTS_SQUINT",
      "Vận nhãn từng mắt",
    ],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Vận nhãn từng mắt",
    radioButtons: [
      {
        label: "Tối đa",
        value: "Tối đa",
        span: 8,
      },
      {
        label: "Hạn chế",
        value: "Hạn chế",
        span: 8,
      },
      {
        label: "Quá mức",
        value: "Quá mức",
        span: 8,
      },
    ],
  },
  {
    label: "Vận nhãn 2 mắt",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Vận nhãn 2 mắt"],
    radioButtons: [
      {
        label: "Tối đa",
        value: "Tối đa",
        span: 12,
      },
      {
        label: "Hạn chế",
        value: "Hạn chế",
        span: 12,
      },
    ],
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    suffix: (
      <Icon
        style={{fontSize: "24px"}}
        component={Icons.file as React.ForwardRefExoticComponent<any>}
      />
    ),
  },

  {
    label: "Lăng kính",
    type: INPUT,
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lăng kính"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
  },
  {
    label: "Lác",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác"],
    radioButtons: [
      {
        label: "Lác hiện",
        value: "Lác hiện",
        span: 12,
      },
      {
        label: "Lác ẩn",
        value: "Lác ẩn",
        span: 12,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "show"],
    hide: true,
  },
];

export const FieldsExtraocular2: Array<DataFormField> = [
  {
    name: [
      "leftJsonValue",
      "EXTRAOCULAR_MOVEMENTS_SQUINT",
      "Vận nhãn từng mắt",
    ],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Vận nhãn từng mắt",
    radioButtons: [
      {
        label: "Tối đa",
        value: "Tối đa",
        span: 8,
      },
      {
        label: "Hạn chế",
        value: "Hạn chế",
        span: 8,
      },
      {
        label: "Quá mức",
        value: "Quá mức",
        span: 8,
      },
    ],
  },
  {
    label: "Vận nhãn 2 mắt",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Vận nhãn 2 mắt"],
    radioButtons: [
      {
        label: "Tối đa",
        value: "Tối đa",
        span: 12,
      },
      {
        label: "Hạn chế",
        value: "Hạn chế",
        span: 12,
      },
    ],
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    suffix: (
      <Icon
        style={{fontSize: "24px"}}
        component={Icons.file as React.ForwardRefExoticComponent<any>}
      />
    ),
  },
  {
    label: "Lăng kính",
    type: INPUT,
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lăng kính"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
  },
  {
    label: "Lác",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác"],
    radioButtons: [
      {
        label: "Lác hiện",
        value: "Lác hiện",
        span: 12,
      },
      {
        label: "Lác ẩn",
        value: "Lác ẩn",
        span: 12,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "show"],
    hide: true,
  },
];
const fieldsTropiaLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác hiện"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác hiện",
    radioButtons: [
      {
        label: "Chiều ngang",
        value: "Chiều ngang",
        span: 8,
      },
      {
        label: "Chiều dọc",
        value: "Chiều dọc",
        span: 8,
      },
      {
        label: "Lác liệt",
        value: "Lác liệt",
        span: 8,
      },
    ],
  },
];
const fieldsTropiaRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác hiện"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác hiện",
    radioButtons: [
      {
        label: "Chiều ngang",
        value: "Chiều ngang",
        span: 8,
      },
      {
        label: "Chiều dọc",
        value: "Chiều dọc",
        span: 8,
      },
      {
        label: "Lác liệt",
        value: "Lác liệt",
        span: 8,
      },
    ],
  },
];
const fieldsHorizontalLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Chiều ngang"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chiều ngang",
    radioButtons: [
      {
        label: "Lác trong",
        value: "Lác trong",
        span: 12,
      },
      {
        label: "Lác ngoài",
        value: "Lác ngoài",
        span: 12,
      },
    ],
  },
];
const fieldsHorizontalRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Chiều ngang"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chiều ngang",
    radioButtons: [
      {
        label: "Lác trong",
        value: "Lác trong",
        span: 12,
      },
      {
        label: "Lác ngoài",
        value: "Lác ngoài",
        span: 12,
      },
    ],
  },
];
const fieldsVerticalLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Chiều dọc"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chiều dọc",
    radioButtons: [
      {
        label: "Hướng lên",
        value: "Hướng lên",
        span: 12,
      },
      {
        label: "Hướng xuống",
        value: "Hướng xuống",
        span: 12,
      },
    ],
  },
];
const fieldsVerticalRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Chiều dọc"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chiều dọc",
    radioButtons: [
      {
        label: "Hướng lên",
        value: "Hướng lên",
        span: 12,
      },
      {
        label: "Hướng xuống",
        value: "Hướng xuống",
        span: 12,
      },
    ],
  },
];
const fieldsParalyticLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác liệt"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác liệt",
    checkbox: [
      {
        label: "MR",
        value: "MR",
        span: 4,
      },
      {
        label: "LR",
        value: "LR",
        span: 4,
      },
      {
        label: "SO",
        value: "SO",
        span: 4,
      },
      {
        label: "SR",
        value: "SR",
        span: 4,
      },
      {
        label: "IR",
        value: "IR",
        span: 4,
      },
      {
        label: "IO",
        value: "IO",
        span: 4,
      },
    ],
  },
];
const fieldsParalyticRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác liệt"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác liệt",
    checkbox: [
      {
        label: "MR",
        value: "MR",
        span: 4,
      },
      {
        label: "LR",
        value: "LR",
        span: 4,
      },
      {
        label: "SO",
        value: "SO",
        span: 4,
      },
      {
        label: "SR",
        value: "SR",
        span: 4,
      },
      {
        label: "IR",
        value: "IR",
        span: 4,
      },
      {
        label: "IO",
        value: "IO",
        span: 4,
      },
    ],
  },
];

const fieldsETLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác trong"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác trong",
    radioButtons: [
      {
        label: "ACS",
        value: "ACS",
        span: 6,
      },
      {
        label: "Sensory",
        value: "Sensory",
        span: 6,
      },
      {
        label: "Infantile",
        value: "Infantile",
        span: 6,
      },
      {
        label: "ICS",
        value: "ICS",
        span: 6,
      },
    ],
  },
];
const fieldsETRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác trong"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác trong",
    radioButtons: [
      {
        label: "ACS",
        value: "ACS",
        span: 6,
      },
      {
        label: "Sensory",
        value: "Sensory",
        span: 6,
      },
      {
        label: "Infantile",
        value: "Infantile",
        span: 6,
      },
      {
        label: "ICS",
        value: "ICS",
        span: 6,
      },
    ],
  },
];
const fieldsXTLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác ngoài"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác ngoài",
    radioButtons: [
      {
        label: "ADS",
        value: "ADS",
        span: 8,
      },
      {
        label: "IDS",
        value: "IDS",
        span: 8,
      },
      {
        label: "Sensory",
        value: "Sensory",
        span: 8,
      },
    ],
  },
];
const fieldsXTRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác ngoài"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác ngoài",
    radioButtons: [
      {
        label: "ADS",
        value: "ADS",
        span: 8,
      },
      {
        label: "IDS",
        value: "IDS",
        span: 8,
      },
      {
        label: "Sensory",
        value: "Sensory",
        span: 8,
      },
    ],
  },
];

const fieldsPhoriaRight: any[] = [
  {
    name: ["rightJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác ẩn"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác ẩn",
    radioButtons: [
      {
        label: "Lác trong",
        value: "Lác trong",
        span: 12,
      },
      {
        label: "Lác ngoài",
        value: "Lác ngoài",
        span: 12,
      },
    ],
  },
];
const fieldsPhoriaLeft: any[] = [
  {
    name: ["leftJsonValue", "EXTRAOCULAR_MOVEMENTS_SQUINT", "Lác ẩn"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Lác ẩn",
    radioButtons: [
      {
        label: "Lác trong",
        value: "Lác trong",
        span: 12,
      },
      {
        label: "Lác ngoài",
        value: "Lác ngoài",
        span: 12,
      },
    ],
  },
];
export {
  fieldsTropiaLeft,
  fieldsTropiaRight,
  fieldsHorizontalLeft,
  fieldsHorizontalRight,
  fieldsVerticalLeft,
  fieldsVerticalRight,
  fieldsParalyticLeft,
  fieldsParalyticRight,
  fieldsETLeft,
  fieldsETRight,
  fieldsXTLeft,
  fieldsXTRight,
  fieldsPhoriaRight,
  fieldsPhoriaLeft,
};
